import React, { useState, useEffect, useRef } from 'react';
import DropDown from "../../../UIComponents/DropDown/DropDown";
import { getSrInitialList, srExport, srTemplate, resetSrSeasonFilter, srBulkSave, massSrSearchFilter, resetSrMassFilter, srSeasonSearchFilter } from '../../../Redux/actions/Sr/Sr';
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { DownloadOutlined, CloseOutlined } from "@ant-design/icons";
import SearchInput from "../../../UIComponents/SearchInput/SearchInput";
import Select from "../../../UIComponents/DropDown/DropDown";
import { useLocation, useNavigate } from "react-router-dom";
import { SyncOutlined } from "@ant-design/icons";
import SrTable from '../Table/SrTable';
import '../../SRT/Dickies/Dickies.css';
import './TrueEnergy.css'
import { srfStyleList } from "../../../Redux/actions/Srf/Srf";
import { toast } from '../../../UIComponents/Toast'
import { canDownloadSampleSetupSheet } from '../../../Utiles/Helper';


const TOTAL_PER_PAGE = 100;
const CHUNK_SIZE = 25;

const TrueEnergy = (containerRef) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileRef = useRef();
  const queryParams = new URLSearchParams(location.search);
  const srRefresh = useSelector((state) => state?.Sr?.srRefreshSpinner);
  const styleListData = useSelector((state) => state?.Srf?.srfFilterData);

  const [seasonOptions, setSeasonOptions] = useState([]);
  const [seasonFilter, setSeasonFilter] = useState([]);
  const [searchFilter, setSearchFilter] = useState([]);
  const [singleFactory, setSingleFactory] = useState([]);
  const [singleColor, setSingleColor] = useState([]);
  const [colorFilter, setColorFilter] = useState();
  const [singleSize, setSingleSize] = useState([]);
  const [sizeFilter, setSizeFilter] = useState();
  const [vendorFilter, setVendorFilter] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const srDataFromDashoard = JSON.parse(localStorage.getItem("srData"));
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const canDownloadSampleSheet = useSelector((state) =>
    canDownloadSampleSetupSheet(state?.Profile?.graphCompleteData)
  );
  const brandNameFromApi = useSelector((state) => state?.Sr?.srBrandNames);
  const [current, setCurrent] = useState(() => {
    const page = queryParams.get("page");
    return page ? parseInt(page) : 1;
  });
  const [pageCount, setPageCount] = useState(() => {
    const size = queryParams.get("pageSize");
    return size ? parseInt(size) : TOTAL_PER_PAGE;
  });
  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };

  const [massFilterData, setMassFilterData] = useState(() => {
    const savedData = localStorage.getItem("massSrFilterData");
    return savedData ?
      { ...JSON.parse(savedData), brand: "True Energy" }
      :
      {
        searchFilter: null,
        brandFilter: "True Energy",
        colorFilter: "",
        sizeFilter: "",
        vendorFilter: "",
        seasonFilter: "",
        brand: "True Energy",
        sale_sample: 0,
      };
  });
  useEffect(() => {
    localStorage.setItem("massSrFilterData", JSON.stringify(massFilterData));
  }, [massFilterData]);
  const srMassFilterData = JSON.parse(localStorage.getItem("srMassData"));
  useEffect(() => {
    localStorage.setItem("srActiveKey", "12");
    if (srMassFilterData) {
      dispatch(
        massSrSearchFilter(
          srMassFilterData?.searchFilter
            ? srMassFilterData?.searchFilter
            : "",
          "True Energy",
          srMassFilterData?.colorFilter ? srMassFilterData?.colorFilter : "",
          srMassFilterData?.sizeFilter ? srMassFilterData?.sizeFilter : "",
          srMassFilterData?.vendorFilter
            ? srMassFilterData?.vendorFilter
            : "",
          0,
          srMassFilterData?.seasonFilter
            ? srMassFilterData?.seasonFilter
            : "",
          current,
          pageCount
        )
      );
      setSearchInput(srMassFilterData?.searchFilter || "");
      setVendorFilter(srMassFilterData?.vendorFilter || undefined);
      setColorFilter(srMassFilterData?.colorFilter || undefined);
      setSizeFilter(srMassFilterData?.sizeFilter || undefined);
      setSeasonFilter(srMassFilterData?.seasonFilter || []);
    }
    else if (srDataFromDashoard) {
      dispatch(
        getSrInitialList(
          "True Energy",
          srDataFromDashoard?.style ? srDataFromDashoard?.style : "",
          srDataFromDashoard?.factory ? srDataFromDashoard?.factory : "",
          0,
          srDataFromDashoard?.season ? srDataFromDashoard?.season : "",
          "",
          1,
          TOTAL_PER_PAGE
        )
      );
      localStorage.removeItem("srMassData");
    }
    else {
      dispatch(getSrInitialList("True Energy", "", "", 0, "", "", 1, TOTAL_PER_PAGE));
    }
  }, []);

  useEffect(() => {
    dispatch(srfStyleList("", ""));
    dispatch(resetSrMassFilter([]));
    // dispatch(srSeasonSearchFilter([]));
    localStorage.removeItem("srMassData");
    localStorage.removeItem("massSrFilterData");
    localStorage.setItem(
      "srData",
      JSON.stringify({
        searchFilter: "",
        vendorFilter: "",
        colorFilter: "",
        sizeFilter: "",
        seasonFilter: "",
        brand: "True Energy",
        sale_sample: 0,
      })
    );
  }, []);
  useEffect(() => {
    const allowedBrands = ["TRUE"];
    const filteredStyles = styleListData.filter((item) =>
      allowedBrands.includes(item?.brand)
    );
    if (!styleListData || !Array.isArray(styleListData)) return;

    const uniqueSeasons = [
      ...new Set(
        styleListData
          .map((item) => item?.season?.trim().toUpperCase())
          .filter(Boolean)
      ),
    ];

    const formattedSeasons = [
      { value: "ALL", label: "Select All" },
      ...uniqueSeasons.map((season) => ({
        value: season,
        label: season,
      })),
    ];

    setSeasonOptions(formattedSeasons);

    const vendors = filteredStyles
      .flatMap((item) => {
        if (Array.isArray(item.factory)) return item.factory;
        if (item.factories) return item.factories.split(",");
        return [];
      })
      .map((vendor) => vendor.trim().toLowerCase())
      .filter(Boolean);

    const uniqueSortedVendors = [...new Set(vendors)]
      .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
      .sort((a, b) => a.localeCompare(b));

    setSingleFactory(uniqueSortedVendors);
    const styleColors = filteredStyles
      .flatMap((item) =>
        item?.colors ? item.colors.split(",").map((c) => c.trim()) : []
      )
      .filter(Boolean);
    setSingleColor([...new Set(styleColors)]);

    const styleSizes = filteredStyles
      .flatMap((item) =>
        item?.sizes ? item.sizes.split(",").map((s) => s.trim()) : []
      )
      .filter(Boolean);
    setSingleSize([...new Set(styleSizes)]);
  }, [styleListData]);

  const exportToExcelTrueEnergy = () => {
    if (!selectedIds || selectedIds.length === 0) {
      toast.error("Please select at least one row");
      return;
    }

    dispatch(
      srExport({
        ids: selectedIds,
      })
    );
    setSelectedIds([])
  };
  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      setSearchFilter(searchInput);
      setCurrent(1);
      setPageCount(TOTAL_PER_PAGE);
      updateQueryParams(1, TOTAL_PER_PAGE);

      localStorage.setItem(
        "srMassData",
        JSON.stringify({
          searchFilter: searchInput,
          brandFilter: "True Energy",
          colorFilter: "",
          sizefilter: "",
          statusFilter: "",
          vendorFilter: "",
          sale_samplefilter: 0,
          seasonFilter: seasonFilter || "",
        })
      );

      dispatch(
        massSrSearchFilter(
          searchInput, // ✅ use input
          "True Energy",
          colorFilter || "",
          sizeFilter || "",
          vendorFilter || "",
          0,
          seasonFilter || "",
          1,
          TOTAL_PER_PAGE
        )
      );
    }
  };
  const onSeasonChange = (values) => {
    if (!values || values.length === 0) {
      handleSeasonClear();
      return;
    }
    setSearchFilter([]);
    setColorFilter();
    setSizeFilter();
    setVendorFilter();
    setSeasonFilter();
    setSearchInput("")
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    dispatch(srSeasonSearchFilter("True Energy", values, 1, TOTAL_PER_PAGE, 0));
    setSeasonFilter(values);
    localStorage.removeItem("srData");
    localStorage.removeItem("massSrFilterData");
    dispatch(resetSrMassFilter([]));
    dispatch(resetSrSeasonFilter([]));
    // dispatch(resetSrData([]));
    setMassFilterData((prevData) => ({ ...prevData, seasonFilter: values }));
  };
  const onSearchChange = (e) => {
    const value = e.target.value || "";

    setSearchInput(value);

    localStorage.setItem(
      "srData",
      JSON.stringify({
        searchFilter: value,
        vendorFilter: vendorFilter || "",
        colorFilter: colorFilter || "",
        sizeFilter: sizeFilter || "",
        seasonFilter: seasonFilter || "",
        brand: "True Energy",
        sale_sample: 0,
      })
    );
  };
  const handleSeasonClear = () => {
    setSearchFilter([]);
    setColorFilter();
    setSizeFilter();
    setVendorFilter();
    setSeasonFilter([]);
    setSearchInput("")
    dispatch(resetSrMassFilter([]));
    dispatch(resetSrSeasonFilter([]));
    const savedData = localStorage.getItem("massSrFilterData");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        const { seasonFilter, ...updatedData } = parsedData;

        localStorage.setItem("massSrFilterData", JSON.stringify(updatedData));

        setMassFilterData((prev) => ({
          ...prev,
          seasonFilter: "",
        }));
        setSeasonFilter();
        dispatch(getSrInitialList("True Energy", "", "", 0, "", "", 1, TOTAL_PER_PAGE));
        updateQueryParams(1, TOTAL_PER_PAGE);
        setCurrent(1);
        setPageCount(TOTAL_PER_PAGE);
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    } else {
      setMassFilterData((prev) => ({
        ...prev,
        seasonFilter: "",
      }));
      setSeasonFilter();
      dispatch(getSrInitialList("True Energy", "", "", 0, "", "", 1, TOTAL_PER_PAGE));
    }
  };
  const onFactoryChange = (value) => {
    setVendorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, vendorFilter: value }));
  };
  const onColorChange = (value) => {
    setColorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, colorFilter: value }));
  };
  const onSizeChange = (value) => {
    setSizeFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, sizeFilter: value }));
  };
  const onRefresh = () => {
    localStorage.removeItem("srMassData");
    localStorage.removeItem("massSrFilterData");
    localStorage.setItem(
      "srData",
      JSON.stringify({
        searchFilter: "",
        vendorFilter: "",
        colorFilter: "",
        sizeFilter: "",
        seasonFilter: "",
        brand: "True Energy",
        sale_sample: 0,
      })
    );
    dispatch(
      getSrInitialList(
        "True Energy",
        "",
        "",
        0,
        "",
        "",
        1,
        TOTAL_PER_PAGE
      )
    );
    dispatch(resetSrMassFilter([]));
    dispatch(resetSrSeasonFilter([]));
    setSearchFilter([]);
    setColorFilter();
    setSizeFilter();
    setVendorFilter();
    setSeasonFilter();
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    setSearchInput("")
  };
  const onSubmitClick = () => {
    setSearchFilter(searchInput);
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);

    dispatch(
      massSrSearchFilter(
        searchInput,
        "True Energy",
        colorFilter || "",
        sizeFilter || "",
        vendorFilter || "",
        0,
        seasonFilter || "",
        1,
        TOTAL_PER_PAGE
      )
    );
  };
  const onSrBulkUpload = (e) => {
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append("sale_sample", "0");
    formData.append("user", userNameMicrosoft);
    dispatch(srBulkSave(formData, "True Energy"));
    e.target.value = null;
    formData = new FormData();
  };
  const exportToTemplate = () => {
    dispatch(srTemplate())
  }
  return (
    <div className="dickies-main-container">
      <div className="dickies-first-two-dropdowns">
        <div className="dickies-drop-down-one">
          <DropDown
            mode="multiple"
            allowClear
            onChange={onSeasonChange}
            // onClear={handleSeasonClear}
            placeholder={"Season"}
            option={seasonOptions}
            value={seasonFilter}
            enableSelectAll
          />
        </div>
        <h2>TRUE ENERGY</h2>
        <div className="dickies-drop-down-two sample-set-export-section">
          <p
            onClick={canDownloadSampleSheet ? exportToTemplate : undefined}
            style={{
              textDecoration: "underline",
              cursor: canDownloadSampleSheet ? "pointer" : "not-allowed",
              opacity: canDownloadSampleSheet ? 1 : 0.5,
            }}
          >
            Download Sample Setup Sheet
          </p>
          <Button icon={<DownloadOutlined />} onClick={exportToExcelTrueEnergy}>
            Export
          </Button>
        </div>
      </div>

      {/* search dropdown button */}
      <div className="search-dropdown-button">
        <div className="dickies-search-input">
          <SearchInput
            // maxLength={10}
            onKeyPress={onSearchEnter}
            onChange={onSearchChange}
            value={searchInput}
            placeholder={"Search by Parent Style"}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9," ]/g, "");
            }}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Vendor"}
            data={singleFactory}
            value={vendorFilter}
            onChange={onFactoryChange}
          ></Select>
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Color"}
            data={singleColor}
            value={colorFilter}
            onChange={onColorChange}
          ></Select>
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Size"}
            data={singleSize}
            value={sizeFilter}
            onChange={onSizeChange}
          ></Select>
        </div>
        <div className="sync-icon">
          <SyncOutlined spin={srRefresh} onClick={onRefresh} />
        </div>
        <div>
          <Button
            onClick={onSubmitClick}
            className="dickies-button"
            children={"SUBMIT"}
          />
        </div>
        <div>
          <Button
            className="dickies-button"
            onClick={() => fileRef.current.click()}
          >
            Bulk Update
          </Button>
          <input
            type="file"
            onChange={onSrBulkUpload}
            accept="image/jpeg/png/jpg , application/pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ref={fileRef}
            hidden
          />
        </div>
      </div>
      <SrTable brand={"True Energy"}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        vendorFilter={vendorFilter}
        setVendorFilter={setVendorFilter}
        colorFilter={colorFilter}
        setColorFilter={setColorFilter}
        sizeFilter={sizeFilter}
        setSizeFilter={setSizeFilter}
        data={massFilterData}
        onSelectionChange={setSelectedIds}
        selectedRows={selectedIds}
        current={current}
        pageCount={pageCount}
        setCurrent={setCurrent}
        setPageCount={setPageCount}
        totalPerPage={TOTAL_PER_PAGE}
        chunkSize={CHUNK_SIZE}
        containerRef={containerRef} 
        seasonFilter={seasonFilter}   />
    </div>
  )
}

export default TrueEnergy;
